import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const PayoutIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.9524 17.25C14.8237 17.25 14.6949 17.2026 14.5933 17.101L12.8998 15.4074C12.7033 15.211 12.7033 14.8858 12.8998 14.6894C13.0962 14.4929 13.4214 14.4929 13.6178 14.6894L14.9524 16.0239L16.2869 14.6894C16.4833 14.4929 16.8085 14.4929 17.0049 14.6894C17.2014 14.8858 17.2014 15.211 17.0049 15.4074L15.3114 17.101C15.2098 17.2026 15.0811 17.25 14.9524 17.25Z"
      fill={props.color}
    />
    <path
      d="M14.9524 17.25C14.6746 17.25 14.4443 17.0197 14.4443 16.7419V7.25806C14.4443 6.98032 14.6747 6.75 14.9524 6.75C15.2301 6.75 15.4605 6.98032 15.4605 7.25806V16.7419C15.4605 17.0197 15.2301 17.25 14.9524 17.25Z"
      fill={props.color}
    />
    <path
      d="M7.99994 4.25C7.80994 4.25 7.61994 4.32 7.46994 4.47L4.96994 6.97C4.67994 7.26 4.67994 7.74 4.96994 8.03C5.25994 8.32 5.73994 8.32 6.02994 8.03L7.99994 6.06L9.96994 8.03C10.2599 8.32 10.7399 8.32 11.0299 8.03C11.3199 7.74 11.3199 7.26 11.0299 6.97L8.52994 4.47C8.37994 4.32 8.18994 4.25 7.99994 4.25Z"
      fill={props.color}
    />
    <path
      d="M7.99994 4.25C7.58994 4.25 7.25 4.59 7.25 5V19C7.25 19.41 7.59 19.75 8 19.75C8.41 19.75 8.75 19.41 8.75 19V5C8.75 4.59 8.40994 4.25 7.99994 4.25Z"
      fill={props.color}
    />
  </svg>
)
